import { useEffect, useState } from 'react';

// 初回マウント時のコンポーネントがブラウザ側で実行しおわったらtrueを返す
// componentのマウント直後であれば下の実装を使うのが好ましいです
// useEffect(() => {
//   console.log("I have been mounted")
// }, [])
// それだけだとまだコンポーネントのstyleなどがブラウザに適用されていないパターンなどで使えます
// Reactのロジック関わるところでは使わないでCSSなどの描画系の問題を解決するのに使ってください

export const useAfterMountedOnBrowser = (): boolean => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setMounted(true);
    }, 0);
  }, []);

  return mounted;
};
